// Feature gating: maps (tier, feature) → allowed, and resolution caps.
// The monolith calls these via the bridge to lock premium effects, decide
// watermarking and clamp export resolution. Pure, table-driven, unit-tested.

import type { Tier, FeatureKey, Resolution } from './types';
import { tierRank } from './tiers';

/** Minimum tier rank required for each gate-able feature. */
const FEATURE_MIN_RANK: Record<FeatureKey, number> = {
  export_no_watermark: 1, // starter+
  cloud_sync: 1, // starter+
  resolution_hd: 2, // creator+
  resolution_4k: 2, // creator+
  resolution_8k: 3, // business
  all_effects: 2, // creator+
  priority_generation: 2, // creator+
  team_seats: 3, // business
  multiplayer: 0, // MVP: open to everyone (incl. free). Bump to gate later.
};

export function canUse(tier: Tier, feature: FeatureKey): boolean {
  return tierRank(tier) >= FEATURE_MIN_RANK[feature];
}

/** Free exports carry a watermark; any paid tier removes it (AC-G1). */
export function shouldWatermark(tier: Tier): boolean {
  return tier === 'free';
}

/** Highest export resolution the tier is allowed to produce. */
export function maxResolution(tier: Tier): Resolution {
  if (canUse(tier, 'resolution_8k')) return '8k';
  if (canUse(tier, 'resolution_4k')) return '4k';
  return '1080p';
}
